function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#00a0af;}.b{fill:#285f74;}.c{stroke:none;}.d{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-20853 -1564)"
}, /*#__PURE__*/React.createElement("g", {
  className: "a",
  transform: "translate(20853 1564)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "c",
  width: 28,
  height: 26,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  className: "d",
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 25,
  rx: 3.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20827.332 1567.782)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M46.8,6.594h-.443V4.458a.347.347,0,0,0,0-.04.355.355,0,0,0-.086-.234L42.711.124l0,0a.359.359,0,0,0-.072-.06L42.612.047a.379.379,0,0,0-.071-.03L42.522.01A.362.362,0,0,0,42.439,0H33.7a.724.724,0,0,0-.723.723V6.594h-.443A1.033,1.033,0,0,0,31.5,7.628V13a1.034,1.034,0,0,0,1.033,1.033h.443v3.678a.724.724,0,0,0,.723.723H45.632a.724.724,0,0,0,.723-.723V14.034H46.8A1.034,1.034,0,0,0,47.831,13V7.628A1.033,1.033,0,0,0,46.8,6.594ZM33.7.723h8.374v3.7a.362.362,0,0,0,.361.361h3.193V6.594H33.7ZM41.815,11.86v1.048H38.366V7.387H39.62V11.86Zm-8.88,1.048,1.6-2.793-1.54-2.728h1.434l.483,1.007c.164.336.287.606.418.918h.016c.131-.352.238-.6.377-.918l.467-1.007h1.425l-1.557,2.7,1.639,2.826H36.253l-.5-1c-.2-.385-.336-.672-.491-.991h-.016c-.115.32-.254.606-.426.991l-.459,1H32.935Zm12.7,4.609H33.7V14.034H45.632v3.483ZM43.9,12.991a3.614,3.614,0,0,1-1.564-.336l.254-1.032a3.189,3.189,0,0,0,1.385.344c.574,0,.877-.238.877-.6,0-.344-.262-.541-.926-.778-.917-.32-1.516-.827-1.516-1.631,0-.942.786-1.663,2.089-1.663a3.388,3.388,0,0,1,1.409.279l-.279,1.008a2.623,2.623,0,0,0-1.155-.262c-.541,0-.8.246-.8.533,0,.352.311.508,1.024.778.975.36,1.434.868,1.434,1.646C46.132,12.2,45.42,12.991,43.9,12.991Z",
  transform: "translate(0 0)"
})));

var SvgExportXls = function SvgExportXls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExportXls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/export_xls.19ac459c.svg";
export { ForwardRef as ReactComponent };